services.service('Validator', function () {
    function isObject(val) {
        return (typeof val === 'object' && !Array.isArray(val));
    }

    validate.formatters.custom = function (errors) {
        return errors.map(function (error) {
            return {
                field: error.attribute,
                value: error.attributes[error.attribute],
                validator: error.validator,
                message: error.error,
                options: error.options
            }
        });
    };

    validate.validators.isTradingTimes = function (value, options, key, attributes) {
        var error;

        //validate type of field
        if (!isObject(value) || value === null) {
            return value + ': Not an object'
        }

        //validate type of day
        Object.keys(value).forEach(function (item) {
            if (!Array.isArray(value[item])) {
                error = item + ': Is not array';
            }

            //validate range in every day
            if (!error) {
                value[item].forEach(function (range) {
                    if (!isObject(range)) {
                        error = item + '.' + range + ': Not an object';
                    }

                    if (!error) {
                        if (!range.hasOwnProperty('CloseHour')) {
                            error = item + '.' + range + ': has no property "CloseHour"';
                        }
                        if (!range.hasOwnProperty('CloseMinute')) {
                            error = item + '.' + range + ': has no property "CloseMinute"';
                        }
                        if (!range.hasOwnProperty('OpenHour')) {
                            error = item + '.' + range + ': has no property "OpenHour"';
                        }
                        if (!range.hasOwnProperty('OpenMinute')) {
                            error = item + '.' + range + ': has no property "OpenMinute"';
                        }
                    }
                })
            }

        });
        if (error) return error;
    };

    validate.options = {
        format: 'custom'
    };

    validate.getPattern = function (type) {
        switch (type) {
        case 'alpha':
            return "[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*";
        case 'phone':
            return "[0-9]{1,}";
        case 'email':
            return "(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))";
        case 'password':
            return "(\\d+[A-Za-z]+|[A-Za-z]+\\d+)[A-Za-z\\d]*";
        case 'number':
            return "([0-9]+)";
        case 'alphanum':
            return "[a-zA-Z0-9-\\.]+";
        case 'alphanumMultiple':
            return "[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*";
        case 'name':
            return "[^[0-9\\]\\'\\.\\?\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\_\\+\\=\\{\\}\\(\\)\\/><\\][\\\\\x22,;|]+";
        case 'freetext':
            return "[^\\'\\.\\?\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\_\\+\\=\\{\\}\\(\\)\\/><\\][\\\\\x22,;|]+";
        case 'address':
            return "[^\\'\\?\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\_\\+\\=\\{\\}\\/><\\][\\\\\x22,;|]+";
        }

    };

    return validate;
});
